<div class="modal fade" id="modaldeliveryProduct" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalToggleLabel">DANH SÁCH SẢN PHẨM</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="col-sm-12 d-flex justify-content-between flex-wrap mb-5">
                    <div class="col-sm-9 d-flex flex-column gap-3">
                        <div class="col-sm-12 d-flex gap-5 flex-wrap justify-content-between">
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataSearch.product_name.label"
                                        :id="dataSearch.product_name.id"
                                        :placeholder="dataSearch.product_name.placeholder"
                                        :value-default="dataSearch.product_name.value"
                                        @inputValue="onChange($event, dataSearch.product_name.id)"
                                        :required="dataSearch.product_name.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataSearch.product_code.label"
                                        :id="dataSearch.product_code.id"
                                        :placeholder="dataSearch.product_code.placeholder"
                                        :value-default="dataSearch.product_code.value"
                                        @inputValue="onChange($event, dataSearch.product_code.id)"
                                        :required="dataSearch.product_code.required"
                                ></InputTextNormal>
                            </div>
                        </div>
                        <div class="col-sm-12 d-flex gap-5 flex-wrap justify-content-between">
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataSearch.product_unit.label"
                                        :id="dataSearch.product_unit.id"
                                        :placeholder="dataSearch.product_unit.placeholder"
                                        :value-default="dataSearch.product_unit.value"
                                        @inputValue="onChange($event, dataSearch.product_unit.id)"
                                        :required="dataSearch.product_unit.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataSearch.product_tax.label"
                                        :id="dataSearch.product_tax.id"
                                        :placeholder="dataSearch.product_tax.placeholder"
                                        :value-default="dataSearch.product_tax.value"
                                        @inputValue="onChange($event, dataSearch.product_tax.id)"
                                        :required="dataSearch.product_tax.required"
                                ></InputTextNormal>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-1 d-flex flex-column justify-content-end">
                        <ButtonSearchComponent :label="labelButtonSearch" @click="searchProducts"></ButtonSearchComponent>
                    </div>
                </div>
                <table class="table">
                    <thead>
                    <tr>
                        <th style="width: 2%;" class="text-center">
                        </th>
                        <th class="text-center" scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="listProductCurrent.length > 0" v-for="product in listProductCurrent" :key="product.id">
                        <td class="text-center"><InputCheckboxOne :id="'select_' + product.id" :value-default="listChecked[product.id]" @inputValue="onChangeSelectProduct($event, product.id)" :checked="listChecked[product.id]"></InputCheckboxOne></td>
                        <td>{{product.product_name}}</td>
                        <td>{{product.product_code}}</td>
                        <td>{{ CommonService.formatPrice(product.product_price) }}</td>
                        <td>{{ CommonService.formatPrice(product.product_selling_price) }}</td>
                        <td>{{product.product_tax}}</td>
                        <td>{{product.product_quantity}}</td>
                        <td>{{product.product_status}}</td>
                        <td>{{product.product_unit}}</td>
                    </tr>
                    <tr v-else>
                        <td colspan="7" class="text-center">Không có sản phẩm nào được tìm thấy</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <PaginateComponent v-if="paginate.pageCount > 1" :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"></PaginateComponent>
            <div class="modal-footer d-flex justify-content-center">
                <button class="btn btn-primary" @click="applyProductSelected">Áp dụng</button>
            </div>
        </div>
    </div>
</div>
